export const EMA_LABEL_SECTIONS = [
  'name_of_the_medicinal_product',
  'qualitative_and_quantitative_composition',
  'pharmaceutical_form',
  'therapeutic_indications',
  'posology_and_method_of_administration',
  'contraindications',
  'special_warnings_and_precautions_for_use',
  'interaction_with_other_medicinal_products_and_other_forms_of_in',
  'fertility_pregnancy_and_lactation',
  'effects_on_ability_to_drive_and_use_machines',
  'undesirable_effects',
  'overdose',
  'pharmacodynamic_properties',
  'pharmacokinetic_properties',
  'preclinical_safety_data',
  'pharmaceutical_particulars',
  'marketing_authorisation_holder',
  'marketing_authorisation_number',
  'date_of_first_authorisation_renewal_of_the_authorisation',
  'date_of_revision_of_the_text',
  'annex_ii',
  'annex_iii'
] as const;

export type EmaLabelSection = (typeof EMA_LABEL_SECTIONS)[number];

export type EmaLabelSectionMap = Record<EmaLabelSection, string | number | null>;

export type EmaLabelSectionValues = Record<EmaLabelSection, string | null>;

export type EmaLabelSeparationResponse = {
  onedrive_url: string;
  s3_url: string | null;
  product_number: string;
  labels: EmaLabelSectionMap;
};

export type EmaLabelSeparationUploadRequest = {
  curator_email: string;
  curator_name: string;
};

export type EmaLabelSeparationUploadResponse = {
  s3_url: string;
  s3_path?: string;
  product_number?: string;
};

export type EmaLabelSeparationLabelsRequest = EmaLabelSectionValues & {
  curator_email: string;
  curator_name: string;
};

export type EmaLabelSeparationLabelsResponse = {
  curation_id: string;
  product_number: string;
  labels: EmaLabelSectionValues;
};

export type EmaLabelSeparationApiResponse<T> = {
  status?: number;
  data?: {
    body?: T | string;
    message?: string;
  };
} | null;
